import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';

export namespace LicenseDependencies {
  const licenseDependencies = {
    [LicenseProductIdEnum.ProductIdBreachWarranty]: LicenseProductIdEnum.ProductIdMdr,
    [LicenseProductIdEnum.ProductIdBreachWarrantyPlus]: LicenseProductIdEnum.ProductIdMdrPlus,
    [LicenseProductIdEnum.ProductIdBreachWarrantyPlusOver1000]: LicenseProductIdEnum.ProductIdMdr,
  };

  const licenseDependToRiskManagement = [
    LicenseProductIdEnum.ProductIdComplianceManager,
    LicenseProductIdEnum.ProductIdExposureManagement,
  ]

  export function getDependenciesForProductId(productId: number) {
    return licenseDependencies[productId] ?? null;
  }

  export function dependentToRiskManagementProductId(productId: number): boolean {
    return licenseDependToRiskManagement.includes(productId);
  }
}
